/**
 * @param {string} response /qcreatesvg or /qcreatepubdoc response
 * @returns {{code: string, ref: string|null}|null} null on success
 */
export function ParseExportFailure(response) {
  if (response == null || response === "") return { code: "unknown", ref: null };
  if (response === "failure") return { code: "unknown", ref: null };
  if (response.charAt(0) !== "{") return null;

  try {
    var body = JSON.parse(response);
    if (body && body.result === "failure")
      return { code: body.code || "unknown", ref: body.ref || null };
  } catch (e) {
    // A filename starting with "{" is still a success.
  }
  return null;
}
